import { render, staticRenderFns } from "./UserCreateAndUpdateFormItems.vue?vue&type=template&id=d5cda0fe&"
import script from "./UserCreateAndUpdateFormItems.vue?vue&type=script&lang=js&"
export * from "./UserCreateAndUpdateFormItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports